exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "mdb-carousel {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\nmdb-slide img {\n  height: 400px;\n  width: 600px;\n  -webkit-box-flex: 'flex-grow';\n      -ms-flex: 'flex-grow';\n          flex: 'flex-grow';\n}\n\n@media only screen and (max-width: 620px) {\n  mdb-slide img {\n    height: 70%;\n    width: 100%;\n    padding: 1em;\n  }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/page_components/welcome/carousel/carousel.component.css
// module id = 377
// module chunks = 1